export function isIpad() {
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const isIpadUA = /iPad/.test(ua);
  const isIpadOS13Plus = platform === "MacIntel" && maxTouchPoints > 2;

  // Additional check to exclude actual Macs
  const isNotMacSafari = !window.matchMedia("(pointer: fine)").matches;

  return isIpadUA || (isIpadOS13Plus && isNotMacSafari);
}
